import { LOCALES } from '@/i18n/types';
import { useI18n } from '@/i18n/useI18n';

type Props = {
  className?: string;
};

export function LanguageSwitcher({ className = '' }: Props) {
  const { locale, setLocale, t } = useI18n();

  return (
    <label className={`lang-switcher ${className}`.trim()}>
      <span className="visually-hidden">{t('lang.label')}</span>
      <select
        aria-label={t('lang.label')}
        value={locale}
        onChange={(e) => setLocale(e.target.value as typeof locale)}
      >
        {LOCALES.map((item) => (
          <option key={item.code} value={item.code}>
            {item.label}
          </option>
        ))}
      </select>
    </label>
  );
}
